<template>
  <div class="pagination-content">
    <el-pagination align="center"
      :currentPage="curPage"
      :page-size="pSize"
      :layout="layout"
      :total="pTotal"
      :page-sizes="pageSizes"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>
<style scoped>
.pagination-content {
  text-align: right;
  padding: 50px 30px;
}
</style>
<script>
export default {
  name: "Pagination",
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 1,
    },
    pageSize: {
      type: [Number, String],
      default: 10,
    },
    total: {
      type: Number,
      required: true,
      default: 0,
    },
    layout: {
      type: String,
      default: "total, prev, pager, next, jumper",
    },
    goTop: {
      type: Boolean,
      default: true,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
  },
  data() {
    return {
    };
  },
  computed: {
    curPage: function () {
      return this.currentPage;
    },
    pSize: function () {
      return this.pageSize;
    },
    pTotal: function () {
      return this.total;
    },
  },

  methods: {
    handleCurrentChange(val) {
      this.$emit("pageChange",val);
    },
    handleSizeChange(val) {
      this.$emit("sizeChange",val);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/comm/components/Pagination.vue